import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';

const useGetEquipmentsAssignable = (reservationId: string) => {
  return useQuery({
    queryKey: ['equipmentsAssignable', reservationId],
    queryFn: () => api.equipments.getEquipmentAssignable(reservationId)
  });
};
export default useGetEquipmentsAssignable;
